// AJ Tracking (10 Oct 2026) – small additions to the order tracking page drawn by the Parcel Panel app
// (/tools/ordertracking). Display only: the app still looks the order up and draws its page; this script only
// adjusts what is shown, using the same answer the app got for the lookup (it reads that answer once more).
// If anything here fails, the app's own page shows as it is.
//
//  1. Shipping updates in the visitor's language: the carrier writes its updates in its own language (CTT in
//     Portuguese for everyone). Each update is shown as one short sentence chosen by the app's status code
//     (the same in every language), with the place the carrier gave under it. The owner's own steps
//     ("in production", "order ready") keep the app's text, which the app already translates.
//  2. "In production" earlier: the app can only show the owner's custom step one day after the order. Here the
//     step lights up a few hours after the order time (sooner when the order contains Urgent Production).
//     It is an estimate from the time passed, not a signal from the workshop.
//  3. Destination carrier: parcels leave with CTT and are delivered by the postal service of the destination
//     country, which is the name customers saw on the shipping page – its name, logo (from the app's own logo
//     library) and tracking page are shown instead.
//  4. Product names in the visitor's language (the app shows the order's original English names).
//
// Texts and hours come from snippets/aj-tracking.liquid. Styles: assets/aj-tracking.css.
(function () {
  if (window.AJTracking) return;
  window.AJTracking = true;

  var configNode = document.getElementById('aj-tracking-config');
  if (!configNode) return;
  var config;
  try { config = JSON.parse(configNode.textContent); } catch (e) { return; }

  var URGENT_PRODUCT_ID = 10242770206986; // "Urgent Production 24h" (product handle ea-add-on-product)
  // The app's drawing of the default custom-step icon (an arrow): desktop and phone versions
  var PRODUCTION_ICON = ['M17.707 9.293', 'M10.707 17.707'];
  // Delivery carrier per destination when the parcel leaves with CTT (country names as the app gives them):
  // name, the logo's file name in the app's logo library, and the carrier's own tracking page ({n} = number;
  // no link = keep the app's link).
  var LOGOS = 'https://cdn.parcelpanel.com/assets/common/images/express/';
  var DESTINATION_CARRIER = {
    Italy: { name: 'Poste Italiane', logo: 'poste-italiane', link: 'https://www.poste.it/cerca/index.html#/risultati-spedizioni/{n}' },
    France: { name: 'La Poste', logo: 'laposte', link: 'https://www.laposte.fr/outils/suivre-vos-envois?code={n}' },
    Germany: { name: 'DHL', logo: 'dhl-germany', link: 'https://www.dhl.de/de/privatkunden/pakete-empfangen/verfolgen.html?piececode={n}' },
    Netherlands: { name: 'PostNL', logo: 'netherlands-post' },
    Belgium: { name: 'Bpost', logo: 'belgium-post', link: 'https://track.bpost.cloud/btr/web/#/search?itemCode={n}&lang=en' },
    Switzerland: { name: 'Swiss Post', logo: 'swiss-post', link: 'https://service.post.ch/ekp-web/ui/entry/search/{n}' },
    'United Kingdom': { name: 'Royal Mail', logo: 'royal-mail', link: 'https://www.royalmail.com/track-your-item#/tracking-results/{n}' },
    Ireland: { name: 'An Post', logo: 'an-post', link: 'https://www.anpost.com/Post-Parcels/Track/History?item={n}' },
    'United States': { name: 'USPS', logo: 'usps', link: 'https://tools.usps.com/go/TrackConfirmAction?tLabels={n}' }
  };

  var lastUrl = '';
  var dataUrl = '';
  var stale = false; // the app has looked something up since we last read the answer
  var own = 0;       // how many of our own requests are still to be reported by the browser
  var data = null;

  // The address of the app's own lookup request, noted as it happens
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (entry.name.indexOf('/api/v2/tracking-info') === -1) return;
        if (own > 0) { own--; return; } // our own re-read of the answer, not a new lookup by the app
        lastUrl = entry.name;
        stale = true;
        queue();
      });
    }).observe({ type: 'resource', buffered: true });
  } catch (e) { return; }

  function app() { return document.getElementById('pp-tracking-page-app'); }

  function shortDate(ms) {
    // same shape as the app's own step dates: short month name + two-digit day ("out 07")
    try {
      var date = new Date(ms);
      var month = new Intl.DateTimeFormat(config.locale, { month: 'short' }).format(date).replace('.', '');
      return month + ' ' + ('0' + date.getDate()).slice(-2);
    } catch (e) { return ''; }
  }

  // "Out for delivery" too early (owner, 10 Oct 2026): for parcels that leave with CTT for another country,
  // the app files a sorting step in Portugal (e.g. "Centro operacional Lisboa", the day after shipping) as
  // "out for delivery". Customers then expect the parcel that day, or fear it is being delivered in the wrong
  // place. A real delivery abroad cannot happen that soon, so an "out for delivery" update dated less than
  // EARLY_DELIVERY_HOURS after the shipping time is shown as "on its way", and the status title and the
  // steps are set back to "in transit" while it is the latest update.
  var EARLY_DELIVERY_HOURS = 60;
  var TRANSIT_ICON = ['M17.816 14c'];
  var DELIVERY_ICON = ['M10 0C5.589'];
  var TRANSIT_BADGE = 'url("https://cdn.parcelpanel.com/assets/shipment_status_icon/202205/in_transit.svg?_v=4")';

  function iconIs(node, starts) {
    var path = node.querySelector('.icon path');
    var d = path ? path.getAttribute('d') || '' : '';
    return starts.some(function (start) { return d.indexOf(start) === 0; });
  }

  function tooEarly(shipment, answer, event) {
    if (!event || event.checkpoint_status !== 'pickup' || shipment.companyCode !== 'ctt') return false;
    var map = (answer.map_api || [])[0];
    if (!DESTINATION_CARRIER[map && map.map_destination_country]) return false;
    var shipped = Number(shipment.order_fulfill_time) * 1000;
    var when = Date.parse(String(event.date_carbon || '').replace(' ', 'T'));
    if (!shipped || !when) return false;
    return when - shipped < EARLY_DELIVERY_HOURS * 3600000;
  }

  // status title and steps back to "in transit" while the latest update is such an early "out for delivery"
  function notOutYet(root, shipment, answer) {
    if (!tooEarly(shipment, answer, (shipment.trackinfo || [])[0])) return;
    var transit = shipment.status_node && shipment.status_node['2'] && shipment.status_node['2'].name;
    var title = root.querySelector('.pp_num_status_show span');
    if (title && transit && shipment.status && shipment.status !== transit && title.textContent.indexOf(shipment.status) > -1) {
      title.textContent = title.textContent.replace(shipment.status, transit);
    }

    var nodes = [].slice.call(root.querySelectorAll('.progress-bar-node'));
    var delivery = nodes.filter(function (n) { return iconIs(n, DELIVERY_ICON); })[0];
    var moving = nodes.filter(function (n) { return iconIs(n, TRANSIT_ICON); })[0];
    if (delivery && moving && delivery.classList.contains('progress-bar-node--active')) {
      delivery.classList.remove('progress-bar-node--active');
      delivery.classList.add('progress-bar-node-disabled');
      var date = delivery.querySelector('.text-wrapper span');
      if (date) date.remove();
      var line = root.querySelector('.line-back-pc .line-front') || root.querySelector('.line-back .line-front');
      var position = moving.style.getPropertyValue('--pp-node-position');
      if (line && position) line.style.setProperty('width', position, 'important');
    }

    var rows = [].slice.call(root.querySelectorAll('.progress-bar-mobile-list'));
    var deliveryRow = rows.filter(function (n) { return iconIs(n, DELIVERY_ICON); })[0];
    var movingRow = rows.filter(function (n) { return iconIs(n, TRANSIT_ICON); })[0];
    if (deliveryRow && movingRow && deliveryRow.classList.contains('progress-bar-mobile-node--active')) {
      deliveryRow.classList.remove('progress-bar-mobile-node--active');
      deliveryRow.classList.add('progress-bar-mobile-disabled');
      var rowDate = deliveryRow.querySelector('.progress-bar-mobile-content span');
      if (rowDate) rowDate.remove();
      var bar = root.querySelector('.progress-bar-mobile-left span');
      if (bar && rows[0]) bar.style.setProperty('height', (movingRow.offsetTop - rows[0].offsetTop + 12) + 'px', 'important');
    }
  }

  // 1. every carrier update as one short sentence in the visitor's language (+ the place, as the carrier gave it)
  function history(root, shipment, answer) {
    var events = shipment.trackinfo || [];
    var items = root.querySelectorAll('.pp_timeline > .timeline-item');
    if (!events.length || items.length !== events.length) return;
    [].forEach.call(items, function (item, index) {
      var event = events[index];
      var early = tooEarly(shipment, answer, event);
      var text = config.status[early ? 'transit' : event.checkpoint_status];
      var content = item.querySelector('.timeline-body-content');
      var line = content && content.querySelector('span');
      if (!text || !line) return;
      if (line.textContent !== text) line.textContent = text;
      var badge = item.querySelector('.timeline-badge');
      if (early && badge && badge.style.backgroundImage !== TRANSIT_BADGE) badge.style.backgroundImage = TRANSIT_BADGE;
      var place = String(event.Details || '').trim();
      var placeNode = content.querySelector('.aj-trk-place');
      if (place && !placeNode) {
        placeNode = document.createElement('div');
        placeNode.className = 'aj-trk-place';
        content.appendChild(placeNode);
      }
      if (placeNode && placeNode.textContent !== place) placeNode.textContent = place;
    });
  }

  // 2. the custom "in production" step, lit a few hours after the order
  function production(root, shipment) {
    var created = Number(shipment.order_create_time) * 1000;
    if (!created) return;
    var urgent = (shipment.products || []).some(function (p) { return Number(p.product_id) === URGENT_PRODUCT_ID; });
    var due = created + (urgent ? config.urgentHours : config.productionHours) * 3600000;
    if (Date.now() < due) return;

    var hasIcon = function (node) {
      var path = node.querySelector('.icon path');
      var d = path ? path.getAttribute('d') || '' : '';
      return PRODUCTION_ICON.some(function (start) { return d.indexOf(start) === 0; });
    };

    // desktop: one line of steps
    var nodes = [].slice.call(root.querySelectorAll('.progress-bar-node'));
    var step = nodes.filter(hasIcon)[0];
    if (step && step.classList.contains('progress-bar-node-disabled')) {
      step.classList.remove('progress-bar-node-disabled');
      step.classList.add('progress-bar-node--active', 'aj-trk-early');
      var wrapper = step.querySelector('.text-wrapper');
      if (wrapper && !wrapper.querySelector('span')) {
        var date = document.createElement('span');
        date.textContent = shortDate(due);
        wrapper.appendChild(date);
      }
      var line = root.querySelector('.line-back-pc .line-front') || root.querySelector('.line-back .line-front');
      var position = step.style.getPropertyValue('--pp-node-position');
      if (line && position) line.style.setProperty('width', position, 'important');
    }

    // phones: steps one under the other
    var rows = [].slice.call(root.querySelectorAll('.progress-bar-mobile-list'));
    var row = rows.filter(hasIcon)[0];
    if (row && row.classList.contains('progress-bar-mobile-disabled')) {
      row.classList.remove('progress-bar-mobile-disabled');
      row.classList.add('progress-bar-mobile-node--active', 'aj-trk-early');
      var content = row.querySelector('.progress-bar-mobile-content');
      if (content && !content.querySelector('span')) {
        var mobileDate = document.createElement('span');
        mobileDate.textContent = shortDate(due);
        content.appendChild(mobileDate);
      }
      var bar = root.querySelector('.progress-bar-mobile-left span');
      if (bar && rows[0]) bar.style.setProperty('height', (row.offsetTop - rows[0].offsetTop + 12) + 'px', 'important');
    }
  }

  // 3. the delivery carrier of the destination country instead of CTT: name, logo, tracking page
  function carrier(root, shipment, answer) {
    if (shipment.companyCode !== 'ctt') return;
    var map = (answer.map_api || [])[0];
    var info = DESTINATION_CARRIER[map && map.map_destination_country];
    var box = root.querySelector('.PP-CarrierInfo');
    if (!info || !box) return;
    var number = shipment.track_number || '';
    var href = info.link && number ? info.link.replace('{n}', encodeURIComponent(number)) : '';
    var label = box.querySelector('.pp_tracking_carrier_top span');
    if (label && label.textContent !== info.name) label.textContent = info.name;
    var logo = box.querySelector('.pp_tracking_carrier_img');
    if (logo) {
      var image = 'url("' + LOGOS + info.logo + '.png")';
      if (logo.style.backgroundImage !== image) logo.style.backgroundImage = image;
      if (logo.getAttribute('aria-label') !== info.name) logo.setAttribute('aria-label', info.name);
      if (href && logo.getAttribute('href') !== href) logo.setAttribute('href', href);
    }
    var link = box.querySelector('.pp_tracking_carrier_bottom a');
    if (link && href && link.getAttribute('href') !== href) link.setAttribute('href', href);
  }

  // 4. product and variant names in the visitor's language, from the store's own public product list
  var catalogue = null;
  var catalogueAsked = false;
  function products(root, shipment) {
    if (/^en/i.test(config.locale)) return;
    var rows = root.querySelectorAll('.pp_tracking_product_show');
    var list = shipment.products || [];
    if (!rows.length || rows.length !== list.length) return;
    if (!catalogue) {
      if (catalogueAsked) return;
      catalogueAsked = true;
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'products.json?limit=250').then(function (response) { return response.json(); }).then(function (json) {
        catalogue = {};
        (json.products || []).forEach(function (product) { catalogue[product.id] = product; });
        apply();
      }).catch(function () {});
      return;
    }
    [].forEach.call(rows, function (row, index) {
      var product = catalogue[list[index].product_id];
      if (!product) return;
      var title = row.querySelector('.pp_tracking_info_img_span a span');
      if (title && title.textContent !== product.title) title.textContent = product.title;
      var variant = (product.variants || []).filter(function (v) { return v.id === Number(list[index].variant_id); })[0];
      var variantNode = row.querySelector('.pp_tracking_info_variant');
      if (variant && variantNode && variant.title !== 'Default Title' && variantNode.textContent !== variant.title) variantNode.textContent = variant.title;
    });
  }

  function apply() {
    var root = app();
    if (!root || !data || !root.querySelector('.pp_tracking_result')) return;
    var shipment = (data.tracking || [])[0];
    if (!shipment) return;
    try { history(root, shipment, data); } catch (e) {}
    try { notOutYet(root, shipment, data); } catch (e) {}
    try { production(root, shipment); } catch (e) {}
    try { carrier(root, shipment, data); } catch (e) {}
    try { products(root, shipment); } catch (e) {}
  }

  function refresh() {
    var root = app();
    if (!root || !root.querySelector('.pp_tracking_result') || !lastUrl) return;
    if (!stale) { apply(); return; }
    stale = false;
    var url = lastUrl;
    dataUrl = url;
    data = null;
    own++;
    fetch(url).then(function (response) { return response.json(); }).then(function (json) {
      if (url !== dataUrl || !json || !json.data) return;
      data = json.data;
      apply();
    }).catch(function () {});
  }

  var waiting = false;
  function queue() {
    if (waiting) return;
    waiting = true;
    setTimeout(function () { waiting = false; refresh(); }, 150);
  }

  function start() {
    var root = app();
    if (!root) return false;
    new MutationObserver(queue).observe(root, { childList: true, subtree: true });
    queue();
    return true;
  }
  if (!start()) document.addEventListener('DOMContentLoaded', start);
})();
